var _path, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCalendar = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11H14.5C14.2239 11 14 11.2239 14 11.5V14.5C14 14.7761 14.2239 15 14.5 15H17.5C17.7761 15 18 14.7761 18 14.5V11.5C18 11.2239 17.7761 11 17.5 11Z",
    fill: "#121214"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 4H20C21.1 4 22 4.9 22 6V20.0045C22 21.1045 21.1 22.0045 20 22.0045H4C2.9 22.0045 2 21.1045 2 20.0045V6C2 4.9 2.9 4 4 4H5V3C5 2.45 5.45 2 6 2C6.55 2 7 2.45 7 3V4H17V3C17 2.45 17.45 2 18 2C18.55 2 19 2.45 19 3V4ZM5 20.0045H19C19.55 20.0045 20 19.5545 20 19.0045V9H4V19.0045C4 19.5545 4.45 20.0045 5 20.0045Z",
    fill: "#121214"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Calendar.c1d402a5.svg";
export { ForwardRef as ReactComponent };